define(["require", "exports", "jquery", "knockout", "../../utils/tools", "../../utils/dateUtils", "../../utils/kendoUtils", "../../models/UserContext", "../../models/BillItemModel"], function (require, exports, $, ko, tools, DateUtils, KendoUtils, UserContext, BillItemModel) {
    "use strict";
    var CustomerBillItems = /** @class */ (function () {
        function CustomerBillItems(customerId, lookupLists, initGridCallback) {
            this.userCanViewCustomerBillItems = ko.observable(UserContext.hasAccess("Admin,CustomerBillItems.View,CustomerBillItems.Edit,CustomerBillItems.Delete"));
            this.userCanEditCustomerBillItems = ko.observable(UserContext.hasAccess("Admin,CustomerBillItems.Edit,CustomerBillItems.Delete"));
            this.userCanDeleteCustomerBillItems = ko.observable(UserContext.hasAccess("Admin,CustomerBillItems.Delete"));
            this.userCanExportCustomerBillItems = ko.observable(UserContext.hasAccess("Admin,CustomerBillItems.Export"));
            this.canViewCdr = ko.observable(UserContext.hasAccess("Admin,CallDetailRecord.View"));
            this.canExportCdr = ko.observable(UserContext.hasAccess("Admin,CallDetailRecord.Export"));
            this.canExportBillLines = ko.observable(UserContext.hasAccess("Admin,Accounting.Export"));
            this.filterBillLinesByStartDate = ko.observable(DateUtils.firstDayOfMonth());
            this.filterBillLinesByEndDate = ko.observable(DateUtils.lastDayOfMonth());
            this.editModel = ko.observable(new BillItemModel());
            this.customerId = ko.observable(0);
            this.btn = ko.observable();
            var self = this;
            self.customerId(customerId);
            self.lookupLists = lookupLists;
            self.customerBillLinesGridStructure = self.lookupLists.GridStructures.CdrBillItemStructure;
            if (this.userCanViewCustomerBillItems()) {
                self.initExportDataSource();
                if (initGridCallback) {
                    initGridCallback(self);
                }
            }
        }
        CustomerBillItems.prototype.initGrid = function () {
            if (this.userCanViewCustomerBillItems()) {
                this.initBillLinesTable();
                this.initBillLinesMenu();
                ko.applyBindings(this, document.getElementById("divBillLinesTable"));
            }
        };
        CustomerBillItems.prototype.initExportDataSource = function () {
            var self = this;
            self.customerBillLinesDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerBillItems/GetCdrBillRecordsForGrid",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.customerId = self.customerId();
                            data.startDate = DateUtils.toIsoStringDate(self.filterBillLinesByStartDate());
                            data.endDate = DateUtils.toIsoStringDate(self.filterBillLinesByEndDate());
                            return data;
                        },
                        dataType: "json"
                    }
                },
                sort: {
                    field: "PeriodDate",
                    dir: "desc"
                },
                schema: {
                    model: self.customerBillLinesGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerBillLinesDataSource = new kendo.data.DataSource(self.customerBillLinesDataSourceOptions);
        };
        CustomerBillItems.prototype.initBillLinesTable = function () {
            var self = this;
            var columns = self.customerBillLinesGridStructure.columns;
            //add actions column
            var actionsColumn = {
                field: "",
                width: "110px",
                template: function (dataItem) {
                    var html = "";
                    if (self.canViewCdr()) {
                        html += '<a class="btn btn-sm btn-primary btn-view" title="Open Details" href="#"><i class="fa fa-eye"></i></a>';
                    }
                    if (!dataItem.IsIncludedInBill) {
                        if (self.userCanEditCustomerBillItems()) {
                            html += '&nbsp;<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit"></i></a>';
                        }
                        if (self.userCanEditCustomerBillItems()) {
                            html += '&nbsp;<a class="btn btn-sm btn-warning btn-add" href="#" title="Include Item to Recurring profile"><i class="fa fa-plus"></i></a>';
                        }
                    }
                    return html;
                }
            };
            if (self.canViewCdr() || self.userCanEditCustomerBillItems()) {
                columns.push(actionsColumn);
            }
            self.customerBillLinesTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: self.customerBillLinesDataSourceOptions,
                gridOptions: {
                    toolbar: kendo.template($("#bill-lines-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    columnMenu: true,
                    scrollable: true,
                    height: 500,
                },
                enableExport: {
                    entityName: "CdrBillItem",
                    title: "Call Bill Lines",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExportCdr()
                },
                gridId: "divBillLinesTable",
                showPagerOnTop: false
            };
            self.customerBillLinesTable.initGrid(gridOptions);
            $("#divBillLinesTable tbody").on("click", ".btn-view", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var gridHeader = $("#divBillLinesTable .k-grid-header").clone();
                var row = $(event.currentTarget).closest("tr");
                var rowClone = row.clone();
                $(".check-row", row).prop("checked", true);
                gridHeader.find("col:first").remove();
                gridHeader.find("col:last").remove();
                gridHeader.find("tr:first").find("th:first").remove();
                gridHeader.find("tr:first").find("th:last").remove();
                rowClone.find("td:first").remove();
                rowClone.find("td:last").remove();
                self.openBillLineDetails(dataItem, rowClone, gridHeader, row);
                event.preventDefault();
            }).on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editBillItem(data.Id, data.Description);
                event.preventDefault();
            }).on("click", ".btn-add", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.addBillItemToRecurringView(data.Id, data.Name, data.Description);
                event.preventDefault();
            });
            self.customerBillLinesTable.setExportDetailsDataSource({
                transport: {
                    read: {
                        url: "/CustomerBillItems/GetBillItemCallDetailRecordsForGrid",
                        type: "POST",
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.lookupLists.GridStructures.CallDetailRecordStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    //aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            });
            self.customerBillLinesTable.hasDetailsToExport = true;
            self.customerBillLinesTable.exportFilterMap = [
                { filterField: "btn", masterRowField: "BTN" },
                { filterField: "customerId", masterRowField: "CustomerId" },
                { filterField: "actionKey", masterRowField: "ActionKey" },
                { filterField: "phoneNumber", masterRowField: "PhoneNumber" },
                {
                    filterField: "callTypesStr", masterRowField: "CallTypes", type: "StringList",
                    value: function (masterRow) {
                        return masterRow.CallTypes.join();
                    }
                },
                {
                    filterField: "startDate", masterRowField: "StartDate", type: "IsoDate",
                    value: function (masterRow) {
                        return DateUtils.toIsoString(masterRow.StartDate);
                    }
                },
                {
                    filterField: "endDate", masterRowField: "EndDate", type: "IsoDate",
                    value: function (masterRow) {
                        return DateUtils.toIsoString(masterRow.EndDate);
                    }
                }
            ];
            self.customerBillLinesTable.detailsGridStructure = self.lookupLists.GridStructures.CallDetailRecordStructure;
            self.initBillLinesTableFilter();
        };
        CustomerBillItems.prototype.openBillLineDetails = function (dataItem, masterRow, masterHeader, row) {
            var self = this;
            tools.editModal({
                title: "Call Detail Records for - " + dataItem.Name,
                modalClass: "full-width",
                type: "info",
                hideFooter: true,
                modalOptions: {},
                buttonTitle: "Close",
                save: function (event, modal) {
                    $(modal).modal("hide");
                },
                close: function () {
                    $(".check-row", row).prop("checked", false);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'call-details-template', data: self }\"></div>");
                    ko.applyBindings(self, modal);
                    self.initBillItemCdrGrid(self.lookupLists.GridStructures.CallDetailRecordStructureAgg, dataItem);
                    masterRow.appendTo($("thead", masterHeader));
                    masterHeader.insertBefore($(".k-grid-header", modal));
                }
            });
        };
        CustomerBillItems.prototype.initBillItemCdrGrid = function (gridStructure, dataItem) {
            var self = this;
            var grid = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerBillItems/GetBillItemCallDetailRecordsForGrid",
                            type: "POST",
                            data: function () {
                                var data = {
                                    btn: dataItem.BTN,
                                    phoneNumber: dataItem.PhoneNumber,
                                    actionKey: dataItem.ActionKey,
                                    customerId: dataItem.CustomerId,
                                    callTypesStr: dataItem.CallTypes.join(),
                                    startDate: DateUtils.toIsoString(dataItem.StartDate),
                                    endDate: DateUtils.toIsoString(dataItem.EndDate)
                                };
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    },
                    aggregate: gridStructure.aggregate,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverAggregates: true,
                    pageSize: 20
                },
                gridOptions: {
                    toolbar: kendo.template($("#cdrDetails-toolbar-template").html()),
                    columns: gridStructure.columns,
                    autoBind: true,
                    height: "400px",
                    scrollable: true,
                    dataBound: function () {
                    }
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: "tblBillItemCdrDetails",
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 56 + 21 + 30 + 7
                }
            };
            grid.initGrid(gridOptions);
            //todo export
            if (self.canExportCdr()) {
                $("#tblBillItemCdrDetails .js-export").on("click", function () {
                    self.customerBillLinesTable.exportTo(true);
                });
            }
            else {
                $("#tblBillItemCdrDetails .js-export").hide();
            }
        };
        CustomerBillItems.prototype.editBillItem = function (theId, description) {
            var self = this;
            var title = "Edit Bill Item";
            self.editModel().CustomerId(self.customerId());
            self.editModel().Id(theId);
            self.editModel().Description(description);
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    $(event.currentTarget).button("loading");
                    self.saveBillItem(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'billitem-edit-template', data: editModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        CustomerBillItems.prototype.saveBillItem = function (btn, modal) {
            var self = this;
            var obj = ko.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerBillItems/SaveBillItem",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.customerId()) {
                        self.customerBillLinesTable.refresh();
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerBillItems.prototype.addBillItemToRecurringView = function (theId, name, description) {
            var self = this;
            var title = "Add Bill Item To Recurring";
            self.editModel().CustomerId(self.customerId());
            self.editModel().Id(theId);
            self.editModel().Name(name);
            self.editModel().Description(description);
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    $(event.currentTarget).button("loading");
                    self.addBillItemToRecurring(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'billitem-add-template', data: editModel }\"></div>");
                    ko.applyBindings(self, modal);
                    self.recurringProfileDropdown = $("#RecurringId", modal).kendoDropDownList({
                        dataTextField: "Text",
                        dataValueField: "Value",
                        dataSource: {
                            transport: {
                                read: {
                                    url: "/CustomerRecurringProfiles/RecurringsLookup",
                                    type: "POST",
                                    dataType: "json",
                                    data: function () {
                                        var data = {};
                                        data.customerId = self.customerId();
                                        return data;
                                    },
                                }
                            },
                            schema: {
                                data: function (response) { return response.Data; },
                                total: "Total",
                                errors: "Errors"
                            },
                            serverPaging: true,
                            serverFiltering: true,
                            serverSorting: true,
                            serverAggregates: false
                        }
                    }).data("kendoDropDownList");
                }
            });
        };
        CustomerBillItems.prototype.addBillItemToRecurring = function (btn, modal) {
            var self = this;
            var obj = {
                recurringId: self.recurringProfileDropdown.value(),
                billItemId: self.editModel().Id()
            };
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/AdminActions/AddBillItemToRecurring",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.customerId()) {
                        self.customerBillLinesTable.refresh();
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerBillItems.prototype.initBillLinesMenu = function () {
            var self = this;
            setTimeout(function () {
                var element = document.getElementById("divBillLinesTable");
                $("#menu", element).kendoMenu();
                // get a reference to the menu widget
                var menu = $("#menu", element).data("kendoMenu");
                // bind to the select event
                menu.bind("select", function (e) {
                    // handle event
                    var actionName = $(e.item).data("action");
                    if (actionName) {
                        self[actionName]();
                    }
                });
            });
        };
        CustomerBillItems.prototype.initBillLinesTableFilter = function () {
            var self = this;
            self.filterBillLinesByStartDate.subscribe(function () {
                self.customerBillLinesTable.refresh();
            });
            self.filterBillLinesByEndDate.subscribe(function () {
                self.customerBillLinesTable.refresh();
            });
        };
        CustomerBillItems.prototype.clearBillLinesFilter = function () {
            var self = this;
            self.filterBillLinesByStartDate(DateUtils.firstDayOfMonth());
            self.filterBillLinesByEndDate(DateUtils.lastDayOfMonth());
        };
        CustomerBillItems.prototype.exportToBillLines = function () {
            var self = this;
            if (self.canExportBillLines) {
                self.customerBillLinesTable.exportTo();
            }
        };
        return CustomerBillItems;
    }());
    return CustomerBillItems;
});
//# sourceMappingURL=customerBillItems.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerBillItems.js
// module id = 178
// module chunks = 2